import type { Ref } from 'react';

function fillRef(ref: Ref<any> | undefined, value: any) {
  if (!ref) return;

  if (typeof ref === 'function') {
    ref(value);
  } else if (typeof ref === 'object') {
    // @ts-expect-error -- This code was written prior to enforcing lint rules
    ref.current = value;
  }
}

/**
 * Merge multiple react refs together into a single function ref
 * Adapted from: https://github.com/gregberge/react-merge-refs/blob/master/src/index.js
 */
// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default function mergeRefs(...refs: Array<Ref<any> | undefined>) {
  return (value: any) => {
    refs.forEach((ref) => fillRef(ref, value));
  };
}
